import React from 'react';
import SarasSideBar from '../../../library/container/appBar/SarasSideBar';

const PageSidebar = (props)=> {
  
  return (
    <SarasSideBar />
  );
}

export default PageSidebar